import React from 'react';
import { Box, Button } from '@mui/material';
import { ChatBubbleOutline as ChatBubbleOutlineIcon } from '@mui/icons-material';
import { useAppSelector, useAppDispatch } from '../../redux/hooks';
import { setActiveConversation, loadMessages, setRightContent } from '../../redux/chat.redux';
import { GroupSettingsPanel } from '../settings-panels';
import PanelShell from './panel-shell';

interface Props {
  groupId: number;
  onClose: () => void;
  embedded?: boolean;
}

// 群聊详情(群聊视图右侧:群人数/群成员/群设置)
export default function GroupDetailPanel({ groupId, onClose, embedded }: Props) {
  const dispatch = useAppDispatch();
  const conversation = useAppSelector((s) => s.chat.conversations.find((c) => c.id === groupId));

  // 去聊天:切换到该群的聊天
  const goChat = () => {
    dispatch(setActiveConversation(groupId));
    dispatch(loadMessages(groupId));
    dispatch(setRightContent({ type: 'chat' }));
  };

  if (!conversation) {
    return (
      <PanelShell title="群聊详情" onClose={onClose} embedded={embedded}>
        <Box sx={{ p: 3, textAlign: 'center', color: 'text.secondary' }}>未找到该群聊</Box>
      </PanelShell>
    );
  }

  return (
    <PanelShell
      title="群聊详情"
      onClose={onClose}
      embedded={embedded}
      footer={
        <Button fullWidth variant="contained" startIcon={<ChatBubbleOutlineIcon />} onClick={goChat} sx={{ borderRadius: 2 }}>
          去聊天
        </Button>
      }
    >
      <GroupSettingsPanel conversation={conversation} onClose={onClose} />
    </PanelShell>
  );
}
